import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CollectionData } from '@klickdata/core/collection';
import { AppScope } from '@klickdata/core/resource';

@Component({
    selector: 'app-content-collection-resources-select',
    templateUrl: './content-collection-resources-select.component.html',
    styleUrls: ['./content-collection-resources-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentCollectionResourcesSelectComponent implements OnInit {
    @Input() accessForm: FormGroup;
    @Input() referenceFilter: string;
    @Input() defaultSorting: string;
    @Input() params: { property: string; items: any[] }[];
    AppScope = AppScope;
    @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
    openedTabIndices = [0];
    public currentTab = 0;
    constructor() {}

    ngOnInit(): void {}
    tabChanged(event: MatTabChangeEvent) {
        this.currentTab = event.index;
        if (!this.openedTabIndices.includes(event.index)) {
            this.openedTabIndices.push(event.index);
        }
    }
}
